import React from 'react'

const ABout = () => {
    return (
        <div className='container-fluid' style={{ width: '90%', margin: '5vh auto' }}>
            <div className='row'>
                <div className='col-md-6 col-sm-10' style={{
                    display: 'flex',
                    flexDirection: "column",
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <img src='../images/about.jpg' className='img-fluid' style={{ width: '330px', height: '330px', objectFit: 'contain', borderRadius: '50%', }} />
                </div>
                <div className='col-md-6 col-sm-10' style={{
                    lineHeight: '2.5rem', display: 'flex',
                    flexDirection: "column",


                }} >

                    Full stack webDeveloper
                    <div class="progress">
                        <div class="progress-bar bg-success" role="progressbar" style={{ width: '12%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    HTML
                    <div class="progress">
                        <div class="progress-bar bg-info" role="progressbar" style={{ width: '23%' }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">

                        </div>
                    </div>
                    CSS
                    <div class="progress">
                        <div class="progress-bar bg-warning" role="progressbar" style={{ width: '35%' }} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">

                        </div>
                    </div>
                    Javascript
                    <div class="progress">
                        <div class="progress-bar bg-danger" role="progressbar" style={{ width: '47%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">

                        </div>
                    </div>
                    React js
                    <div class="progress">
                        <div class="progress-bar bg-waening" role="progressbar" style={{ width: '59%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">

                        </div>
                    </div>


                    NPM
                    <div class="progress">
                        <div class="progress-bar bg-ingo" role="progressbar" style={{ width: '70%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">

                        </div>
                    </div>

                    Git
                    <div class="progress">
                        <div class="progress-bar bg-success" role="progressbar" style={{ width: '82%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">

                        </div>
                    </div>

                    Node js
                    <div class="progress">
                        <div class="progress-bar bg-secondary" role="progressbar" style={{ width: '89%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">

                        </div>
                    </div>

                    Mongo DB database
                    <div class="progress">
                        <div class="progress-bar bg-danger" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">

                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default ABout;